import { MutationTree } from 'vuex'
import * as types from './mutation-types'
import LocationsState from '../../types/LocationsState'
import Location from '../../types/Location'

const mutations: MutationTree<LocationsState> = {
  [types.SET_LOCATIONS] (state, payload: Location[]) {
    state.locations = payload
  },
  [types.SET_CURRENT_LOCATION] (state, payload: Location) {
    state.current_location = payload
  }
}

export default mutations
